import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, isRef as _isRef, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"240px"} }

import {reactive, ref, watch} from "vue";
import {useRouter} from "vue-router";
import {storeToRefs} from "pinia";
import {useRegistrationInquiryStore} from "@/modules/RegistrationInquiry/store";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective
} from "@syncfusion/ej2-vue-grids";
import {DataManager} from "@syncfusion/ej2-data/src/manager";
import {Api, gridActionFailure} from "@/shared/services/api";
import {CustomAdaptor} from "@/shared/types/CustomAdaptor";
import SogPage from "@/shared/ui/SogPage.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";

/* eslint-disable @typescript-eslint/no-explicit-any */


export default /*@__PURE__*/_defineComponent({
  __name: 'RegistrationInquiryListPage',
  setup(__props) {

const _router = useRouter();
const _grid = ref<any>(null);
const _store = useRegistrationInquiryStore();
const {statusFilter: _statusFilter, selectedId: _selectedId} = storeToRefs(_store);

const _statusItems = reactive([
  {id: "open", value: "Offen (Entwurf, Freigegeben, Fehler)"},
  {id: "Draft", value: "Entwurf"},
  {id: "Approved", value: "Freigegeben"},
  {id: "Failed", value: "Fehlgeschlagen"},
  {id: "Sent", value: "Gesendet"},
  {id: "Discarded", value: "Verworfen"},
]);
const _fields = {text: "value", value: "id"};

// Status als Filter-Prädikat: das Backend liest es aus $filter
const _adaptor = new CustomAdaptor();
_adaptor.addPredicate("status", "equal", _statusFilter.value);

const _dataManager = new DataManager({
  url: Api.baseUrl + "/VehicleRegistrationInquiryList",
  adaptor: _adaptor,
  crossDomain: true,
});

const _pageSettings = {
  pageSize: _store.listPageSettings.pageSize,
  currentPage: _store.listPageSettings.currentPage,
  pageSizes: ["All", 10, 25, 50, 100]
};

// Seitenwechsel und Seitengröße merken
function onActionComplete(args: any) {
  if (args.requestType !== "paging") return;
  const t_pageSettings = _grid.value?.ej2Instances?.pageSettings;
  if (t_pageSettings?.currentPage) {
    _store.listPageSettings.currentPage = t_pageSettings.currentPage;
  }
  if ([10, 25, 50, 100].includes(t_pageSettings?.pageSize)) {
    _store.listPageSettings.pageSize = t_pageSettings.pageSize;
  }
}

// Nach dem Laden die zuletzt markierte Anfrage wieder markieren
function onDataBound() {
  if (!_selectedId.value || !_grid.value?.ej2Instances) return;
  const t_records: any[] = _grid.value.ej2Instances.getCurrentViewRecords();
  const t_index = t_records.findIndex(t => t.id === _selectedId.value);
  if (t_index >= 0) {
    _grid.value.ej2Instances.selectRow(t_index);
  } else {
    _selectedId.value = undefined;
  }
}

function getCountText(field: string, data: any) {
  const t_all = data.itemCount ?? 0;
  const t_unknown = data.unknownCount ?? 0;
  return t_all > t_unknown ? `${t_unknown} (+${t_all - t_unknown})` : `${t_unknown}`;
}

function onRowSelected(args: any) {
  _selectedId.value = args.data?.id;
}

function onRowDeselected(args: any) {
  if (!args.isInteracted) return;
  _selectedId.value = undefined;
}

function onRecordDoubleClick(args: any) {
  if (args.rowData?.id) openDetails(args.rowData.id);
}

function onDetails() {
  if (_selectedId.value) openDetails(_selectedId.value);
}

function openDetails(id: string) {
  _router.push("/registrationinquiry/details/" + id);
}

// Statuswechsel: zurück auf Seite 1 und neu laden
watch(_statusFilter, (value) => {
  _adaptor.removePredicate("status");
  _adaptor.addPredicate("status", "equal", value);
  if (_grid.value?.ej2Instances?.pageSettings) {
    _grid.value.ej2Instances.pageSettings.currentPage = 1;
  }
  _grid.value?.refresh();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, { title: "Recherche-Mails an Zulassungsstellen" }, {
    default: _withCtx(() => [
      _createVNode(SogCard, { title: "" }, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-information",
                tooltip: "Details anzeigen",
                onClick: onDetails
              }, null, 512), [
                [_vShow, _unref(_selectedId)]
              ]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(SogDropDownList, {
                  modelValue: _unref(_statusFilter),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(_statusFilter) ? (_statusFilter).value = $event : null)),
                  placeholder: "Status",
                  "data-source": _statusItems,
                  fields: _fields,
                  "popup-width": "240px"
                }, null, 8, ["modelValue", "data-source"])
              ]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(_unref(GridComponent), {
                ref_key: "_grid",
                ref: _grid,
                "data-source": _unref(_dataManager),
                "allow-paging": true,
                "allow-sorting": true,
                width: "auto",
                "allow-resizing": true,
                "show-column-menu": false,
                "allow-text-wrap": true,
                "page-settings": _pageSettings,
                "row-selected": onRowSelected,
                "row-deselected": onRowDeselected,
                "record-double-click": onRecordDoubleClick,
                "action-complete": onActionComplete,
                "data-bound": onDataBound,
                "action-failure": _unref(gridActionFailure)
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ColumnsDirective), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ColumnDirective), {
                        field: "createDate",
                        "header-text": "Erstellt",
                        "auto-fit": true,
                        format: "dd.MM.yyyy",
                        type: "dateTime"
                      }),
                      _createVNode(_unref(ColumnDirective), {
                        field: "officeName",
                        "header-text": "Zulassungsstelle",
                        "auto-fit": true
                      }),
                      _createVNode(_unref(ColumnDirective), {
                        field: "mailTypeText",
                        "header-text": "Art",
                        "auto-fit": true
                      }),
                      _createVNode(_unref(ColumnDirective), {
                        field: "unknownCount",
                        "header-text": "Zulassungen",
                        "auto-fit": true,
                        "value-accessor": getCountText
                      }),
                      _createVNode(_unref(ColumnDirective), {
                        field: "statusText",
                        "header-text": "Status",
                        "auto-fit": true
                      }),
                      _createVNode(_unref(ColumnDirective), {
                        field: "subject",
                        "header-text": "Betreff",
                        "auto-fit": true
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data-source", "action-failure"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})